import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // for offline
      networkMode: 'always',
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});
